import axios from "../../../utils/authAxios";
const api_base_url =
  process.env.REACT_APP_API_BASEURL + "/HomeCompany";

export const getHomeCompany = async () => {
  return axios.get(`${api_base_url}`).then((res) => {
    return res;
  });
}

export const addHomeCompany = async (newHomeCompany) => {
  const { data } = await axios.post(api_base_url, {
    ...newHomeCompany,
  });
  return data;
};

export const editHomeCompany = async (editHomeCompanyData) => {
  const { data } = await axios.put(api_base_url, editHomeCompanyData);
  return data;
};

export const deleteHomeCompany = async (ids) => {
  return axios.delete(api_base_url, {
    data: ids,
  });
};


